<template lang="pug">
  footer(:class="[$style.footer, $style.localFooter]")
    div(
      :class="isRebrand? $style.rebrandLayout : ''"
      class="container font-semibold"
    )
      div(:class="$style.siteInfo")
        div(:class="$style.contact")
          div(class="mb-ds-sm hidden md:block")
            PhoneNumber(
              :font-size="24"
              show-text)
          p(class="mb-ds-md text-xs hidden md:block")
            | We’re here from
            br
            | Monday to Friday 8am - 8pm ET
          p(class="flex justify-center items-center md:inline")
            a(
              href="https://www.linkedin.com/company/anyvan"
              target="_blank"
              :class="$style.mediaIcon"
              aria-label="linkedin")
              Icon(
                transform="scale(0.6)"
                :size="30"
                name="i:linkedin")
            a(
              href="https://x.com/anyvan"
              target="_blank"
              :class="$style.mediaIcon"
              aria-label="x")
              Icon(
                transform="scale(0.6)"
                :size="30"
                name="i:x")
            a(
              href="https://www.facebook.com/AnyVanUK/"
              target="_blank"
              :class="$style.mediaIcon"
              aria-label="facebook")
              Icon(
                transform="scale(0.6)"
                :size="30"
                name="i:facebook")
        nav(:class="$style.links")
          a(:href="`${$config.public.v4Host}/us/about-us`" rel="nofollow") About us
          a(:href="`${v4Host}/send-goods/vehicle_move`") Get shipping quotes
          a(:href="`${$config.public.v4Host}/us/contact-us`" rel="nofollow") Contact us
          a(:href="`${$config.public.v4Host}/us/become-an-anyvan-shipping-partner`") Become a Shipping Partner
        div(:class="[$style.trustPilot, 'text-center md:text-left']")
          client-only
            Trustpilot(
              theme="light"
              :width="Breakpoints_matchMedia('md') ? null : 168")

      hr(:class="$style.hr")

      div(:class="$style.legal")
        div(:class="$style.copy")
          nav
            a(
              :href="`${$config.public.v4Host}/us/privacy-policy`"
              rel="nofollow"
              target="_blank") Privacy policy
            span |
            a(
              :href="`${v4Host}/terms-and-conditions`"
              target="_blank") Terms of use
          div(class="text-2xs text-center md:text-sm lg:text-left")
            | Copyright © 2009 - {{currentYear}} AnyVan, All rights reserved.

</template>

<script lang="ts">
import FooterBase from "~/components/base/footerBase"
import { getV4Host } from "~/scripts/useful-functions"
import { LOCALE } from "~/constants/locale"

export default defineComponent({
  name: "TheFooterUS",
  extends: FooterBase,
  props: {
    uri: {
      type: String,
      default: ""
    }
  },
  computed: {
    v4Host(): string {
      return getV4Host(this.$config.public.v4Host, LOCALE.US)
    }
  }
})
</script>

<style lang="scss" module>
@import "~/assets/scss/footer.scss";
.footer {
  hr {
    margin-bottom: 4px;

    @screen md {
      margin-top: 16px;
    }
  }

  .trustPilot {
    a {
      @screen md {
        @apply -ml-ds-ms p-ds-ms;
      }
    }
  }
}
.legal {
  display: block;
  margin-bottom: 0;

  .copy {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 24px;
    margin-left: 0;

    & > nav {
      width: 100%;
      min-width: fit-content;
      justify-content: center;

      a,
      span {
        width: auto;
        padding: 12px 4px;
      }
    }

    & > div {
      width: 100%;
      min-width: fit-content;
    }

    @screen md {
      flex-wrap: nowrap;

      & > nav {
        justify-content: space-between;
      }

      & > div {
        text-align: right;
      }
    }

    @screen lg {
      & > nav {
        @apply -ml-ds-ms justify-start;

        a,
        span {
          @apply p-ds-ms;
        }
      }
    }
  }
}
</style>
